var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtractIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6673 7.00016C13.6673 10.6821 10.6825 13.6668 7.00065 13.6668C3.31875 13.6668 0.333984 10.6821 0.333984 7.00016C0.333984 3.31826 3.31875 0.333496 7.00065 0.333496C10.6825 0.333496 13.6673 3.31826 13.6673 7.00016ZM7.00065 6.3335C7.36884 6.3335 7.66732 6.63197 7.66732 7.00016V10.3341C7.66732 10.7023 7.36884 11.0008 7.00065 11.0008C6.63246 11.0008 6.33398 10.7023 6.33398 10.3341V7.00016C6.33398 6.63197 6.63246 6.3335 7.00065 6.3335ZM7.00065 5.00016C7.36884 5.00016 7.66732 4.70169 7.66732 4.3335C7.66732 3.96531 7.36884 3.66683 7.00065 3.66683C6.63246 3.66683 6.33398 3.96531 6.33398 4.3335C6.33398 4.70169 6.63246 5.00016 7.00065 5.00016Z",
    fill: "#33383F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractIcon);
export default __webpack_public_path__ + "static/media/Subtract_Icon.3f2c91ab3383a0c401e5bd2d96429320.svg";
export { ForwardRef as ReactComponent };